import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'

export const StyledButton = styled(Button)`
  &:not(:last-child) {
    margin-right: 10px;
  }
` as typeof Button
